export default "__VITE_ASSET__D$YRJGx2__"